export default __webpack_public_path__ + "static/media/imageTum6.f8feb56d.jpg";